import FilterDateRange from './components/FilterDateRange/FilterDateRange';
import FilterSelect from './components/FilterSelect/FilterSelect';
import FilterNumberRange from './components/FilterNumberRange/FilterNumberRange';
import FilterString from './components/FilterString/FilterString';
import FilterMultiSelect from './components/FilterMultiSelect/FilterMultiSelect';
import FilterDate from './components/FilterDate/FilterDate';
import FilterNumber from './components/FilterNumber/FilterNumber';
import { FilterData } from '../FilterForm/FilterForm';
import { Filter } from '../../types/types';

interface IFilterInputProps {
  onChange: (filterData: FilterData) => void;
  filter: Filter;
  filterData?: FilterData;
}

export default function FilterInput({
  onChange,
  filter,
  filterData,
}: IFilterInputProps) {
  switch (filter.type) {
    case 'DATE':
      return (
        <FilterDate
          onChange={onChange}
          filter={filter}
          filterData={filterData}
        />
      );
    case 'DATERANGE':
      return (
        <FilterDateRange
          onChange={onChange}
          filter={filter}
          filterData={filterData}
        />
      );

    case 'NUMBERRANGE':
      return (
        <FilterNumberRange
          onChange={onChange}
          filter={filter}
          filterData={filterData}
        />
      );
    case 'NUMBER':
      return (
        <FilterNumber
          onChange={onChange}
          filter={filter}
          filterData={filterData}
        />
      );
    case 'STRING':
      return (
        <FilterString
          onChange={onChange}
          filter={filter}
          filterData={filterData}
        />
      );
    case 'SELECT':
      return (
        <FilterSelect
          onChange={onChange}
          filter={filter}
          filterData={filterData}
        />
      );
    case 'MULTISELECT':
      return (
        <FilterMultiSelect
          onChange={onChange}
          filter={filter}
          filterData={filterData}
        />
      );
    default:
      return null;
  }
}
